import React from "react";
import { NavLink } from "react-router-dom";

import {
	IcCalendarBlack,
	IcCarSettingGPS,
	IcCarSettingImg,
	IcCarSettingInfo,
	IcCarSettingPaper,
	IcCarSettingTrips,
	IcCarSettingPrice,
	IcExtraFee,
	IcCarSettingTime,
	IcCarSettingDelivey,
	IcListAddress,
} from "../common/svg";

export default class CarSettingSidebar extends React.Component {
	onRentingModeChange = (event) => {
		this.props.onRentingModeChange(event);
	};

	render() {
		const { car, handler, carId, reddot } = this.props;

		return (
			<div className="sidebar sidebar-settings hide-on-med-and-down">
				<ul>
					<li className="heading">
						<p>THÔNG TIN CHUNG</p>
					</li>
					<li>
						<NavLink className={handler === "#infosetting" ? "active" : ""} to={`/carsetting/${carId}#infosetting`}>
							<IcCarSettingInfo /> Thông tin
						</NavLink>
					</li>
					<li>
						<NavLink className={handler === "#photossetting" ? "active" : ""} to={`/carsetting/${carId}#photossetting`}>
							<IcCarSettingImg /> Hình ảnh
						</NavLink>
					</li>
					<li>
						<NavLink className={handler === "#paperssetting" ? "active" : ""} to={`/carsetting/${carId}#paperssetting`}>
							<IcCarSettingPaper /> Giấy tờ xe
							{reddot && <span className="has-reddot"></span>}
						</NavLink>
					</li>
					<li>
						<NavLink className={handler === "#gpssetting" ? "active" : ""} to={`/carsetting/${carId}#gpssetting`}>
							<IcCarSettingGPS /> GPS
						</NavLink>
					</li>
					<li>
						<NavLink className={handler === "#tripssetting" ? "active" : ""} to={`/carsetting/${carId}#tripssetting`}>
							<IcCarSettingTrips /> Quản lý chuyến
						</NavLink>
					</li>

					<li className={`heading ${car.sd !== 1 ? "text-disabled" : ""}`}>
						<p>CHO THUÊ TỰ LÁI</p>
						<div className="custom-switch">
							<input
								type="checkbox"
								id="cb_sd"
								name="selfDrive"
								checked={this.props.car.sd}
								onChange={this.onRentingModeChange}
							/>
							<label htmlFor="cb_sd" />
						</div>
						{car.sd === 1 && car.timeApprovedSD === 0 && (
							<span className="status">
								<span className="status orange-dot"></span>Đang chờ duyệt
							</span>
						)}
					</li>

					{car.sd === 1 && (
						<div style={{ transition: ".3s ease all" }}>
							<li>
								<NavLink
									className={handler === "#pricesetting" ? "active" : ""}
									to={`/carsetting/${carId}#pricesetting`}>
									<IcCarSettingPrice /> Giá cho thuê
								</NavLink>
							</li>
							<li>
								<NavLink
									className={handler === "#calendarsetting" ? "active" : ""}
									to={`/carsetting/${carId}#calendarsetting`}>
									<IcCalendarBlack /> Lịch xe
								</NavLink>
							</li>
							<li>
								<NavLink
									className={handler === "#rentingtimesetting" ? "active" : ""}
									to={`/carsetting/${carId}#rentingtimesetting`}>
									<IcCarSettingTime /> Thiết lập thời gian cho thuê
								</NavLink>
							</li>
							<li>
								<NavLink
									className={handler === "#deliverysetting" ? "active" : ""}
									to={`/carsetting/${carId}#deliverysetting`}>
									<IcCarSettingDelivey /> Giao xe tận nơi
								</NavLink>
							</li>
							<li>
								<NavLink className={handler === "#extrafee" ? "active" : ""} to={`/carsetting/${carId}#extrafee`}>
									<IcExtraFee /> Phụ phí
								</NavLink>
							</li>
							<li>
								<NavLink
									className={handler === "#policiessetting" ? "active" : ""}
									to={`/carsetting/${carId}#policiessetting`}>
									<IcListAddress /> Thủ tục cho thuê
								</NavLink>
							</li>
						</div>
					)}

					<li className={`heading ${car.wd !== 1 ? "text-disabled" : ""}`}>
						<p>CHO THUÊ CÓ TÀI XẾ </p>
						<div className="custom-switch">
							<input
								type="checkbox"
								id="cb_wd"
								name="withDriver"
								checked={this.props.car.wd}
								onChange={this.onRentingModeChange}
							/>
							<label htmlFor="cb_wd" />
						</div>
						{car.wd === 1 && car.timeApprovedWD === 0 && (
							<span className="status">
								<span className="status orange-dot"></span>Đang chờ duyệt
							</span>
						)}
					</li>
					{car.wd === 1 && (
						<div style={{ transition: ".3s ease all" }}>
							<li>
								<NavLink
									className={handler === "#wdpricesetting" ? "active" : ""}
									to={`/carsetting/${carId}#wdpricesetting`}>
									<IcCarSettingPrice />
									Giá cho thuê
								</NavLink>
							</li>
							<li>
								<NavLink
									className={handler === "#wdcalendarsetting" ? "active" : ""}
									to={`/carsetting/${carId}#wdcalendarsetting`}>
									<IcCalendarBlack /> Lịch xe
								</NavLink>
							</li>
							<li>
								<NavLink
									className={handler === "#wdrentingtimesetting" ? "active" : ""}
									to={`/carsetting/${carId}#wdrentingtimesetting`}>
									<IcCarSettingTime /> Thiết lập thời gian cho thuê
								</NavLink>
							</li>
							<li>
								<NavLink
									className={handler === "#wddeliverysetting" ? "active" : ""}
									to={`/carsetting/${carId}#wddeliverysetting`}>
									<IcCarSettingDelivey /> Đưa đón tận nơi
								</NavLink>
							</li>
							<li>
								<NavLink
									className={handler === "#wdpoliciessetting" ? "active" : ""}
									to={`/carsetting/${carId}#wdpoliciessetting`}>
									<IcListAddress /> Thủ tục cho thuê
								</NavLink>
							</li>
						</div>
					)}
				</ul>
			</div>
		);
	}
}
